import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Button, Container, FloatingLabel, Form, Image, InputGroup } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Birthday from '../domain/Birthday.ts';
import Email from '../domain/Email';
import HomePage from '../domain/HomePage';
import InstagramId from '../domain/InstagramId';
import OnetimePassword from '../domain/OnetimePassword';
import Password from '../domain/Password';
import ProfileImage from '../domain/ProfileImage';
import RegistInfo from '../domain/RegistInfo.ts';
import SelfIntroduction from '../domain/SelfIntroduction';
import Sex from '../domain/Sex';
import TwitterId from '../domain/TwitterId';
import UserName from '../domain/UserName';
import * as ImageUtil from '../service/ImageUtil';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import Footer from './Footer';
import Header from './Header';
import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';

async function getReferrerUserName(){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/regist/referrerUserName").then((r)=>r.json().then((json)=>{
        return json
    }))
}
async function oneTimePasswordSend(email){
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/onetime/regist",{email:email})
        .then((r)=>r.json().then((json)=>{
        return json
    }))
}
async function regist(email,password,userName,homePage,twitterId,instagramId,sex,birthday,selfIntroduction,onetimePassword,img,dialog){
    let registInfo = new RegistInfo({email:new Email(email),password:new Password(password),userName:new UserName(userName),
        homePage:new HomePage(homePage),twitterId:new TwitterId(twitterId),instagramId:new InstagramId(instagramId),sex:new Sex(sex),birthday:new Birthday(birthday),
        selfIntroduction:new SelfIntroduction(selfIntroduction),onetimePassword:new OnetimePassword(onetimePassword),profileImage:new ProfileImage(img)})
    // 必須・文字数・パターン
    if(!registInfo.validate(dialog)){
        return false
    }
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/regist/ourt",registInfo.values).then((r)=>{
        return r.json().then((json)=>{
            if(json.result){
                localStorage.setItem("isLoggined",json.result)
                localStorage.setItem("userId",json.userId)
                localStorage.setItem("userName",json.userName)
                localStorage.setItem("accessToken",json.accessToken)//本番では保持しない
            } else {
                dialog("エラー",json.errors)
            }
            return json.result
        })
    })
}

const Regist = (props) => {
    const {t,i18n} = useTranslation()
    const [profileImage, setProfileImage] = useState('')
    const [referrerUserName,setReferrerUserName] = useState([])
    const [oneTimePasswordSended, setOneTimePasswordSended] = useState(false)

    const [readTerms,setReadTerms] = useState(false)
    const [readGuideline,setReadGuideline] = useState(false)
    const [readPrivacyPolicy,setReadPrivacyPolicy] = useState(false)
    const [loading,setLoading] = useState(false)

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = t("regist.signup") + " - アワートAI"
    },[i18n.language])

    useEffect(() => {
        getReferrerUserName().then(json => {
            if(json.result){
                setReferrerUserName(json.referrerUserName)
            }
        })
    },[])

    return (
    <div className="wrapper">
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <Container className='mt-3 mb-3' style={{width:"360px"}}>
            <h3>{t("regist.signup")}</h3>
            <p className='d-inline '>{t("setting.account.profileImage")}</p><br />
            <Image id="load-image" src={profileImage} style={{"width":"250px",borderRadius:"125px"}} /><br />
            <Button onClick={(e) => document.getElementById("file").click()}>{t("setting.account.selectImage")}</Button><br /><br />
            <Form.Control type="file" accept=".jpg,.jpeg,.gif,.png,.webp" className='d-none' id="file" onChange={(e) => ImageUtil.loadImage(e.currentTarget.files,setProfileImage,true)} />
            <FloatingLabel controlId="email" label={t("setting.account.email")+" ("+t("common.required")+"、"+t("common.private")+")"} className="mb-3">
                <Form.Control type="email" defaultValue="" />
            </FloatingLabel>
            <FloatingLabel controlId="password" label={t("setting.account.password")+" ("+t("common.required")+")"} className="mb-3">
                <Form.Control type="password" placeholder="" autoComplete="new-password" />
            </FloatingLabel>
            <p>{t("setting.passwordReset.characterString")}</p>
            <FloatingLabel controlId="name" label={t("setting.account.userName") + " ("+t("common.required")+")"} className="mb-3">
                <Form.Control type="text" cows="10" />
            </FloatingLabel>
            <p className='d-inline '>{t("setting.account.sex")} <span style={{fontSize:"12px",color:"#555555"}}>({t("common.required")}、{t("common.private")})</span></p>
            <Form.Select id="sex" className="mb-3">
                <option></option>
                <option value="1">{t("setting.account.male")}</option>
                <option value="2">{t("setting.account.female")}</option>
            </Form.Select>
            <FloatingLabel controlId="birthday" label={t("setting.account.birthday")+" ("+t("common.required")+"、"+t("common.private")+")"} className="mb-3">
                <Form.Control type="date" />
            </FloatingLabel>
            <Button variant='outline-primary' onClick={() => {
                if(new Email(document.getElementById("email").value).validate(dialog,true)){
                    dialog("確認",t("common.onetimePasswordSentMessage"))
                    oneTimePasswordSend(document.getElementById("email").value)
                    setOneTimePasswordSended(true)
                }
            }} className="mb-1">{t("setting.passwordReset.sendOnetimePassword")}</Button>
            <div className="mb-3">{t("setting.passwordReset.sendMessage")}</div>
            <FloatingLabel controlId="onetime-password" label={t("common.onetimePassword")} style={{display:oneTimePasswordSended ? "block" : "none"}}>
                <Form.Control type="number" cows="10" />
            </FloatingLabel>
            <FloatingLabel controlId="referrer-user-name" label={t("common.referrerUserName")}>
                <Form.Control type="text" value={referrerUserName} disabled />
            </FloatingLabel><br />
            <Button variant='outline-primary'
            onClick={() => {
                dialog("招待制度について",
                <Container>
                    利用者の招待を受けて登録することで、<br />
                    招待した人、招待された人の両者に特典が付与される制度です。<br /><br />
                    2段階に分けて特典が付与されます。<br /><br />
                    ①招待を受けてユーザー登録後にSMS認証することで、両者に2000ポイント<br />
                    ②招待された利用者が、10投稿以上行うことで、両者に3000ポイント<br /><br />
                    ■招待するために必要なこと<br />
                    ・招待する側<br />
                    招待する利用者はSMS認証完了することで、マイページの招待ボタンがクリックできるようになります。<br />
                    ・招待される側<br />
                    招待者のマイページにある「招待を受けて登録」ボタンから登録します。
                </Container>
                )
            }}>招待制度について</Button>
            <br /><br />
            <Link to={"/terms"} target="_blank">{t("common.termsOfService")}</Link><br />
            <Link to={"/guideline"} target="_blank">{t("common.guideline")}</Link><br />
            <Link to={"/privacy"} target="_blank">{t("common.privacyPolicy")}</Link><br />
            <br />
            <InputGroup className="mb-3" style={{maxWidth:"350px",margin:"0 auto"}} controllId="read-terms">
                <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={false} onChange={(e) => {
                    setReadTerms(e.currentTarget.checked)
                }} />
                <Form.Control type="text" value={t("common.checkedTerms")} readOnly />
            </InputGroup>
            <InputGroup className="mb-3" style={{maxWidth:"350px",margin:"0 auto"}} controllId="read-guideline">
                <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={false} onChange={(e) => {
                    setReadGuideline(e.currentTarget.checked)
                }} />
                <Form.Control type="text" value={t("common.checkedGuideline")} readOnly />
            </InputGroup>
            <InputGroup className="mb-3" style={{maxWidth:"350px",margin:"0 auto"}} controllId="read-privacy-policy">
                <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={false} onChange={(e) => {
                    setReadPrivacyPolicy(e.currentTarget.checked)
                }} />
                <Form.Control type="text" value={t("common.checkedPrivacyPolicy")} readOnly />
            </InputGroup>
            <LoadingButton variant='contained' loading={loading} onClick={() => {
                if(!readTerms || !readGuideline || !readPrivacyPolicy){
                    dialog(t("common.confirm"),t("common.pleaseCheckAll"))
                    return
                }
                setLoading(true)
                regist(
                    document.getElementById("email").value,
                    document.getElementById("password").value,
                    document.getElementById("name").value,
                    "",
                    "",
                    "",
                    document.getElementById("sex").value,
                    document.getElementById("birthday").value,
                    "",
                    document.getElementById("onetime-password").value,
                    profileImage,
                    dialog
                ).then((r)=>{
                    setLoading(false)
                    if(r){
                        window.location.href = "/"
                    }
                })
            }} className="mt-3" disabled={!readTerms || !readGuideline || !readPrivacyPolicy}>{t("common.agreeToTheTerms")}</LoadingButton>
            <p className='mt-3'>※捨てアドレスなど不確定なメールアドレスでの登録はできません。使用した場合はアカウントが停止され、今後アカウントの作成は行えなくなります。</p>
        </Container>
        <Footer />
    </div>
    )
}

export default Regist;
